import "./shared/logger";
import "./v2/main";
import { trackPageView } from "./shared/tracker";

trackPageView();
